



















import { Component, Vue, Watch } from 'vue-property-decorator'
import List from '@/components/list.vue'
import Tab from '@/components/tab.vue'
import { list, getOwner } from '@/api/task/common'
import { PAGINATION_PARAM, crowdTypeList } from '@/global/constants'
import { goTop, isLogin } from '../../../global/utils'

@Component({
  components: {
    List,
    Tab
  }
})
export default class MyTeamTask extends Vue {
  private tabsTypeList: object[] = crowdTypeList
  private dataList: object = []
  private loading: boolean = false
  private total: number = 0
  private dataOwner: object = []
  private params: object = {
    team_join: 1, //是否参与
    join: null,
    team_is_pass_exp: null,
    is_pass_exp: null,
    type: 1,
    step: null,
    sort: 3,
    q: null,
    ...PAGINATION_PARAM
  }
  private created() {
    this.getList(this.params)
  }

  // step 切换
  private changeType(data) {
    data = data === '0' ? null : data
    this.params = Object.assign(this.params, { step: data, page: 1 })
    this.getList(this.params)
  }

  // 获取列表数据
  private async getList(params) {
    this.loading = true
    try {
      const data: any = await list(params)
      this.$nextTick(() => {
        this.dataList = data ? data.rows : []
        this.total = data ? data.total : 0
      })
    } catch (err) {
      console.log(err)
    }
    this.loading = false
    goTop()
  }

  // page切换
  public changePage(data) {
    this.params = Object.assign(this.params, { page: data })
    this.getList(this.params)
  }
}
